import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { LOCATION_DETAIL } from 'bento-ordering/locations/constants/entities';
import PageLoadSpinner from 'bento-ordering/base/ui_components/PageLoadSpinner';
import { MENU_ITEMS_DETAIL } from 'bento-ordering/menus/constants/entities';

const withLoading = (WrappedComponent, entity) => {
  class LoadingScreen extends React.Component {
    static propTypes = {
      restaurantLocations: PropTypes.object,
      cart: PropTypes.object,
      menu: PropTypes.object,
      menuItemsDetail: PropTypes.object
    };

    render() {
      /**
       * Here we want to make sure both the locations loaded
       * and the cart id loaded before we display the
       * necessary data for location detail.
       */
      const { restaurantLocations, cart, menu, menuItemsDetail } = this.props;
      let Component = WrappedComponent;

      switch (entity) {
        case LOCATION_DETAIL:
          if (restaurantLocations.isFetching || cart.isFetchingLocation) {
            Component = PageLoadSpinner;
          }
          break;
        case MENU_ITEMS_DETAIL:
          if (
            entity === MENU_ITEMS_DETAIL &&
            (menu.isFetching || menuItemsDetail.isFetchingLocation)
          ) {
            Component = PageLoadSpinner;
          }
          break;
        default:
          if (this.props[entity].isFetching) {
            Component = PageLoadSpinner;
          }
          break;
      }
      return <Component {...this.props} />;
    }
  }

  /* TODO: would be to good to refactor this to pass flat props */
  const mapStateToProps = ({
    cart,
    restaurantLocations,
    menuItemsDetail,
    menu
  }) => ({
    cart,
    restaurantLocations,
    menuItemsDetail,
    menu
  });

  return connect(mapStateToProps)(LoadingScreen);
};

export default withLoading;
